import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  urlCreateMT,
  urlCreateMTwithHD,
  urlUpdateMT,
  urlUpdateStatus,
} from "../../helpers";
import {
  STATUS_PENGERJAAN_DISETUJUI,
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENDING,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_PROSES,
  STATUS_PENGERJAAN_REJECT,
  STATUS_PENGERJAAN_SELESAI,
} from "../../../HelpDesk/helpers";
import moment from "moment";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_DISETUJUI = {
  label: "SETUJUI",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PROSES = {
  label: "PROSES",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENDING = {
  label: "PENDING",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_TOLAK = {
  label: "TOLAK",
  color: "danger",
  state: true,
  disabled: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_REVISI = {
  label: "REVISI",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_SELESAI = {
  label: "SELESAI",
  color: "green",
  state: true,
  disabled: false,
};

const ModalSimpan = ({
  setShowModal,
  resetForm,
  setNewDataReqList,
  rowsSelect,
}) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledDisetujui, setDisabledDisetujui] = useState(SHOW_DISETUJUI);
  const [disabledProses, setDisabledProses] = useState(SHOW_PROSES);
  const [disabledPending, setDisabledPending] = useState(SHOW_PENDING);
  const [disabledTolak, setDisabledTolak] = useState(SHOW_TOLAK);
  const [disabledSelesai, setDisabledSelesai] = useState(SHOW_SELESAI);
  const { validasi } = useContext(FormContext);

  const { formData, setFormData } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.gudang_id) ||
        isNull(formData.unit_id) ||
        isNull(formData.tanggal_service) ||
        isNull(formData.pic) ||
        isNull(formData.user_request)
      ) {
        switch (true) {
          case isNull(formData.unit_id):
            defaultToastError("Harap pilih unit !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.gudang_id):
            defaultToastError("Harap pilih gudang !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case formData.tanggal_service === "":
            defaultToastError("Tanggal service tidak boleh kosong !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.pic):
            defaultToastError("PIC tidak boleh kosong !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.user_request):
            defaultToastError("Username dibutuhkan !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          default:
            defaultToastError("Harap lengkapi form purchase order!");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
        }
      } else {
        const api = await instance4.post(
          isNull(formData.id_helpdesk_header) ? urlCreateMT : urlCreateMTwithHD,
          {
            gudang_id: formData.gudang_id,
            unit_id: formData.unit_id,
            tanggal_service: moment(formData.tanggal_service)
              .local()
              .format("YYYY-MM-DD"),
            is_vendor: isNull(formData.vendor_id) ? false : true,
            vendor_id: formData.vendor_id,
            pic: formData.pic,
            user_request: formData.user_request,
            id_helpdesk_header: formData.id_helpdesk_header,
            remark: formData.remark,
            barang: rowsSelect,
          }
        );
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            id: res.data.id,
            isOpenDraf: true,
            isProcess: false,
          });
          setNewDataReqList(res.data.id);
        } else {
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          defaultToastError(res?.message);
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdateMT, {
          id: formData.id,
          gudang_id: formData.gudang_id,
          unit_id: formData.unit_id,
          tanggal_service: moment(formData.tanggal_service)
            .local()
            .format("YYYY-MM-DD"),
          is_vendor: isNull(formData.vendor_id) ? false : true,
          vendor_id: formData.vendor_id,
          pic: formData.pic,
          user_request: formData.user_request,
          id_helpdesk_header: formData.id_helpdesk_header,
          remark: formData.remark,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          await setNewDataReqList(formData.id);
          defaultToastSuccess(res?.message);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledUpdate(SHOW_UPDATE);
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickDisetujui = async (e) => {
    e.preventDefault();
    setDisabledDisetujui(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledDisetujui(SHOW_DISETUJUI);
        } else {
          const api = await instance4.post(urlUpdateStatus, {
            id_service_header: formData.id,
            status_service: STATUS_PENGERJAAN_DISETUJUI,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              status_service: STATUS_PENGERJAAN_DISETUJUI,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.id);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledDisetujui(SHOW_DISETUJUI);
        }
      } catch (error) {
        setDisabledDisetujui(SHOW_DISETUJUI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledDisetujui(SHOW_DISETUJUI);
      defaultToastError("Anda tidak memiliki akses untuk menyetujui!");
    }
  };

  const handleClickProses = async (e) => {
    e.preventDefault();
    setDisabledProses(DISABLED_BUTTON_SUBMIT);
    // const barang = listREQ;
    // const checkBarang = barang.filter((e) => e.status_cek_barang === null);
    // if (checkBarang.length === 0) {
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledProses(SHOW_PROSES);
      } else {
        const api = await instance4.post(urlUpdateStatus, {
          id_service_header: formData.id,
          status_service: STATUS_PENGERJAAN_PROSES,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            status_service: STATUS_PENGERJAAN_PROSES,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.id);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledProses(SHOW_PROSES);
      }
    } catch (error) {
      setDisabledProses(SHOW_PROSES);
      defaultToastError(error?.response?.data?.message);
    }
    // }
    // else{
    //   setDisabledProses(SHOW_PROSES);
    //   defaultToastError(
    //     "Tidak dapat melanjutkan, masih terdapat barang yang belum dipilih KATEGORInya !"
    //   );
    // }
  };

  const handleClickPending = async (e) => {
    e.preventDefault();
    setDisabledPending(DISABLED_BUTTON_SUBMIT);
    // if (validasi) {
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledPending(SHOW_PENDING);
      } else {
        const api = await instance4.post(urlUpdateStatus, {
          id_service_header: formData.id,
          status_service: STATUS_PENGERJAAN_PENDING,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            status_service: STATUS_PENGERJAAN_PENDING,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.id);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledPending(SHOW_PENDING);
      }
    } catch (error) {
      setDisabledPending(SHOW_PENDING);
      defaultToastError(error?.response?.data?.message);
    }
    // } else {
    //   setDisabledPending(SHOW_PENDING);
    //   defaultToastError("Anda tidak memiliki akses untuk menyetujui!");
    // }
  };

  const handleClickSelesai = async (e) => {
    e.preventDefault();
    setDisabledSelesai(DISABLED_BUTTON_SUBMIT);
    // if (validasi) {
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledSelesai(SHOW_SELESAI);
      } else {
        const api = await instance4.post(urlUpdateStatus, {
          id_service_header: formData.id,
          status_service: STATUS_PENGERJAAN_SELESAI,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            status_service: STATUS_PENGERJAAN_SELESAI,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.id);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledSelesai(SHOW_SELESAI);
      }
    } catch (error) {
      setDisabledSelesai(SHOW_SELESAI);
      defaultToastError(error?.response?.data?.message);
    }
    // } else {
    //   setDisabledSelesai(SHOW_SELESAI);
    //   defaultToastError(
    //     "Anda tidak memiliki akses untuk menyelesaikan permintaan!"
    //   );
    // }
  };

  const handleClickTolak = async (e) => {
    e.preventDefault();
    setDisabledTolak(DISABLED_BUTTON_SUBMIT);
    // if (validasi) {
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledTolak(SHOW_TOLAK);
      } else {
        const api = await instance4.post(urlUpdateStatus, {
          id_service_header: formData.id,
          status_service: STATUS_PENGERJAAN_REJECT,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            status_service: STATUS_PENGERJAAN_REJECT,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.id);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledTolak(SHOW_TOLAK);
      }
    } catch (error) {
      setDisabledTolak(SHOW_TOLAK);
      defaultToastError(error?.response?.data?.message);
    }
    // } else {
    //   setDisabledTolak(SHOW_TOLAK);
    //   defaultToastError("Anda tidak memiliki akses untuk menolak permintaan!");
    // }
  };

  // const handleChange = (text) => (e) => {
  //   setFormData({
  //     ...formData,
  //     [text]: e.target.value,
  //   });
  // };
  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{ marginBottom: "1rem" }}>
        {/* {formData.status_service === STATUS_PENGERJAAN_PENGAJUAN ||
        formData.status_service === STATUS_PENGERJAAN_DISETUJUI ||
        formData.status_service === STATUS_PENGERJAAN_PROSES ||
        formData.status_service === STATUS_PENGERJAAN_PENDING ? (
          <InputTextArea
            id="remark_verifikasi"
            label={"Keterangan/Catatan"}
            name=""
            className="w-full"
            value={formData.remark_verifikasi2}
            placeholder={""}
            onChange={handleChange("remark_verifikasi2")}
            rows={"3"}
          />
        ) : (
          <></>
        )} */}
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          isProcess={formData.isProcess}
          formData={formData}
          disabledOpenDraft={disabledOpenDraft}
          disabledUpdate={disabledUpdate}
          disabledProses={disabledProses}
          disabledPending={disabledPending}
          disabledDisetujui={disabledDisetujui}
          disabledTolak={disabledTolak}
          disabledSelesai={disabledSelesai}
          handleClickOpenDraf={handleClickOpenDraf}
          handleClickUpdate={handleClickUpdate}
          handleClickDisetujui={handleClickDisetujui}
          handleClickProses={handleClickProses}
          handleClickPending={handleClickPending}
          handleClickSelesai={handleClickSelesai}
          handleClickTolak={handleClickTolak}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  isProcess,
  formData,
  disabledOpenDraft,
  disabledUpdate,
  disabledProses,
  disabledPending,
  disabledDisetujui,
  disabledTolak,
  disabledSelesai,
  handleClickOpenDraf,
  handleClickUpdate,
  handleClickDisetujui,
  handleClickProses,
  handleClickPending,
  handleClickSelesai,
  handleClickTolak,
}) => {
  return (
    <>
      {(isOpenDraf && !isNull(formData.id)) ||
      (!isOpenDraf && !isNull(formData.id)) ? (
        formData.status_service === STATUS_PENGERJAAN_PENGAJUAN ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledDisetujui.color}
              onClick={(e) =>
                disabledDisetujui.disabled ? null : handleClickDisetujui(e)
              }
              name={disabledDisetujui.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) =>
                disabledTolak.disabled ? null : handleClickTolak(e)
              }
              name={disabledTolak.label}
              size='lg'
            />
          </>
        ) : formData.status_service === STATUS_PENGERJAAN_DRAFT ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledProses.color}
              onClick={(e) =>
                disabledProses.disabled ? null : handleClickProses(e)
              }
              name={disabledProses.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) =>
                disabledUpdate.disabled ? null : handleClickUpdate(e)
              }
              name={disabledUpdate.label}
              size='lg'
            />
          </>
        ) : formData.status_service === STATUS_PENGERJAAN_DISETUJUI ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledProses.color}
              onClick={(e) =>
                disabledProses.disabled ? null : handleClickProses(e)
              }
              name={disabledProses.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledPending.color}
              onClick={(e) =>
                disabledPending.disabled ? null : handleClickPending(e)
              }
              name={disabledPending.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) =>
                disabledTolak.disabled ? null : handleClickTolak(e)
              }
              name={disabledTolak.label}
              size='lg'
            />
          </>
        ) : formData.status_service === STATUS_PENGERJAAN_PROSES ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledSelesai.color}
              onClick={(e) =>
                disabledSelesai.disabled ? null : handleClickSelesai(e)
              }
              name={disabledSelesai.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledPending.color}
              onClick={(e) =>
                disabledPending.disabled ? null : handleClickPending(e)
              }
              name={disabledPending.label}
              size='lg'
            />
          </>
        ) : formData.status_service === STATUS_PENGERJAAN_PENDING ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledProses.color}
              onClick={(e) =>
                disabledProses.disabled ? null : handleClickProses(e)
              }
              name={disabledProses.label}
              size='lg'
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) =>
                disabledTolak.disabled ? null : handleClickTolak(e)
              }
              name={disabledTolak.label}
              size='lg'
            />
          </>
        ) : formData.status_service === STATUS_PENGERJAAN_SELESAI ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>PENGERJAAN TELAH SELESAI</>
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>PERMINTAAN DITOLAK</>
          </div>
        )
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) =>
            disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)
          }
          size='lg'
        />
      )}
    </>
  );
};

export default ModalSimpan;
